export enum QueryParameters {
  PageIndex = 'pageIndex',
  Filter = 'filter',
  SearchTerm = 'searchTerm',
  SortById = 'sortById',
  SortByDesc = 'sortByDesc',
}
